"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bodymovin = require("bodymovin");

var _bodymovin2 = _interopRequireDefault(_bodymovin);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _data = require("../../assets/data.json");

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledDiv = _styledComponents2.default.div.withConfig({
  displayName: "Loader__StyledDiv",
  componentId: "sc-1tt0wgv-0"
})(["height:200px;width:200px;"]);

class Loader extends _react.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.animation = null, _temp;
  }

  initialize(ref) {
    if (!this.animation) {
      this.animation = _bodymovin2.default.loadAnimation({
        container: ref,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: _data2.default
      });
    }
  }

  render() {
    return _react2.default.createElement(StyledDiv, { ref: ref => this.initialize(ref) });
  }
}

exports.default = Loader;